<template>
    <v-dialog v-model="show" max-width="600px" scrollable persistent>
        <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
            <v-card-title class="text-h5 lighten-2">
                Exportar muestras</v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete dense outlined clearable label="Buscar distribuidor" v-model="distributor"
                                :search-input.sync="searchDistributor" no-data-text="No se encontro distribuidor"
                                :item-text="formatItemText" :items="distributorList" return-object
                                prepend-inner-icon="mdi-magnify"></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="dates"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-combobox v-model="dates" multiple chips small-chips
                                        label="Selecciona rango de fechas" prepend-icon="mdi-calendar" readonly
                                        v-bind="attrs" v-on="on" clearable outlined dense></v-combobox>
                                </template>
                                <v-date-picker v-model="dates" multiple no-title scrollable locale="es">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">
                                        Cerrar
                                    </v-btn>
                                    <v-btn text color="primary" @click="handleSave" :disabled="dates.length !== 2">
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-btn color="gray" block @click="show = false" dark :disabled="isLoading">Cerrar</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn color="primary" block @click="exportData"
                                :disabled="dates.length !== 2 || !distributor" :loading="isLoading">
                                <v-icon> mdi-file-excel </v-icon>
                                Exportar</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
//Vuex
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
// library
import dayjs from "dayjs";
export default {
    components: {},
    data: () => ({
        isLoading: false,
        dates: [],
        menu: false,
        distributor: null,
        distributorList: [
        ],
        searchDistributor: null,
    }),
    props: {
        value: Boolean,
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    async created() {
        await this.getDistributors()
    },
    methods: {
        ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
        ...mapActions("organization", ["getDistributorsByName"]),
        ...mapActions("reception", ["exportSamplesSampled"]),
        handleSave() {
            if (this.dates.length === 2) {
                this.$refs.menu.save(this.dates);
            }
        },
        async exportData() {
            try {
                this.isLoading = true;
                let payload = {
                    distributorId: this.distributor._id,
                    initialDate: this.dates[0],
                    finalDate: this.dates[1],
                };

                let response = await this.exportSamplesSampled({
                    params: payload,
                    body: {}
                });

                console.log(response);

                // check if theres some to export
                if (response.samples.length == 0) {
                    this.SET_ALERT_TYPE({
                        visible: true,
                        type: "info",
                        text: "No se encontraon muestras para exportar",
                        timeout: 6000,
                    });
                } else {
                    // download file exported
                    let currentDate = this.dateFormat(new Date());
                    let fileTitle = `Muestras exportadas - ${currentDate}`;
                    this.exportCSVFile([
                        "Fecha",
                        "Hora",
                        "Cliente",
                        "Poligono",
                        "Submuestras",
                        "Cultivo",
                        "QR",
                        "Folio",
                        "Muestra",
                        "Asesor"
                    ], response.samples, fileTitle);
                    this.SET_ALERT_TYPE({
                        visible: true,
                        type: "success",
                        text: "Muestras exportdas",
                        timeout: 4000,
                    });
                    this.show = false
                }
            } catch (error) {
                console.log(error);
                this.SET_ALERT_TYPE({
                    visible: true,
                    type: "error",
                    text: error.message,
                    timeout: 4000,
                });
            } finally {
                this.isLoading = false;                
            }

        },
        async getDistributors() {
            try {
                let payload = {
                    search: this.searchDistributor
                }
                let response = await this.getDistributorsByName(payload)
                this.distributorList = response.distributors
            } catch (error) {
                console.log("Error getDistributors: ", error);

            }
        },
        formatItemText(item) {
            let template = "";
            if (item.billingInformation) {
                template = `${item.billingInformation.companyName} - ${item.companyName}`;
            } else {
                template = `${item.companyName}`;
            }
            return template;
        },
        exportCSVFile(headers, items, fileTitle) {
            if (headers) {
                items.unshift(headers);
            }

            // Convert Object to JSON
            var jsonObject = JSON.stringify(items);

            var csv = this.convertToCSV(jsonObject);

            var exportedFilenmae = fileTitle + ".csv" || "export.csv";

            var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            if (navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, exportedFilenmae);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) {
                    // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", exportedFilenmae);
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
        convertToCSV(objArray) {
            var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
            var str = "";

            for (var i = 0; i < array.length; i++) {
                var line = "";
                for (var index in array[i]) {
                    if (line != "") line += ",";

                    line += array[i][index];
                }

                str += line + "\r\n";
            }

            return str;
        },
        dateFormat(value) {
            const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
            return date ? date : "----";
        },
    },
    watch: {
        async searchDistributor(newValue) {
            await this.getDistributors()
        }
    }
};
</script>